import React, { ComponentType, useContext } from 'react'

export interface ModalInjectedProps
  extends Pick<ModalContextValues, 'hideModal' | 'isModalOpen'> {
  /**
   * @deprecated - use hideModal
   */
  onCancel?: never
}

export interface ModalContextValues {
  component: ComponentType<ModalInjectedProps> | null
  props: { [key: string]: any }
  isModalOpen?: boolean
  cancelOnClickOutside: boolean
  showModal: <T extends ModalInjectedProps>(
    modal: ComponentType<T>,
    props?: OmitSafe<T, keyof ModalInjectedProps>
  ) => void
  showRestrictedModal: <T extends ModalInjectedProps>(
    modal: ComponentType<T>,
    props?: OmitSafe<T, keyof ModalInjectedProps>
  ) => void
  hideModal: () => void
}

const ModalContext = React.createContext<ModalContextValues>({
  component: null,
  props: {},
  isModalOpen: false,
  cancelOnClickOutside: true,
  showModal: () => {},
  showRestrictedModal: () => {},
  hideModal: () => {},
})

export const useModalContext = (): ModalContextValues =>
  useContext(ModalContext)

export default ModalContext
